import { render, staticRenderFns } from "./header_flow.vue?vue&type=template&id=04339afd&scoped=true"
import script from "./header_flow.vue?vue&type=script&lang=js"
export * from "./header_flow.vue?vue&type=script&lang=js"
import style0 from "./header_flow.vue?vue&type=style&index=0&id=04339afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04339afd",
  null
  
)

export default component.exports